var spoiler_default = {
  "fontElementMap": "mWFky",
  "hideText": "NdCmW",
  "onHoverText": "ZPUEn",
  "hideBlock": "QyxHy",
  "smallBlur": "WocK4",
  "mediumBlur": "TIjOv",
  "largeBlur": "baZt1",
  "hideBlock_gallery": "sa9ac",
  "overlay": "_8xnSf",
  "overlay_gallery": "PbLCX",
  "revealSpoilerBtn": "-O5Iy",
  "isMobile": "uHPW7",
  "onHoverBtn": "RAbFF",
  "spoilerWrapper": "Mc3FA",
  "spoilerDescription": "JkxxN",
  "spoilerContainer": "Qc0qn",
  "spoilerContainer_Gallery": "M84Co"
};
export {
  spoiler_default as default
};
//# sourceMappingURL=spoiler-scss.js.map
